// Default onboarding form data
export const defaultOnboardingFormData = {
    peopleAmount: undefined,
    actionType: [],
    place: "",
    dates: [],
    packagingType: "",
    spaceType: "",
    specialRequests: [],
    note: ""
};